export default class preloaderControl {
  constructor(parent) {
    this.parent = $(parent)
    this.preloader = $('.jQueryPreloader')
    this.preloaderTemplate = '<div class="preloaderWrap jQueryPreloader">'
    this.preloaderTemplate += '<div class="preloader">'
    this.preloaderTemplate += '<span></span>'
    this.preloaderTemplate += '<span></span>'
    this.preloaderTemplate += '<span></span>'
    this.preloaderTemplate += ' <span></span>'
    this.preloaderTemplate += ' </div></div>'
  }

  showPreloader() {
    if (this.parent.css('position') == 'static') {
      this.parent.css('position', 'relative')
    }

    $(this.preloaderTemplate).appendTo(this.parent)
    this.preloader.hide()
    this.preloader.fadeIn(1000)
  }

  removePreloader() {
    this.preloader = $('.jQueryPreloader')
    this.preloader.fadeOut(400)
    setTimeout(function() {
      $('.jQueryPreloader').remove()
    }, 400)
  }

  changeStyles(styles) {
    this.parent.find('.preloaderWrap.jQueryPreloader').css(styles)
  }
}
